import { useRef } from 'react';
import PropTypes from 'prop-types';
import { isStorageAvailable } from 'chameleon/ui-stack/ui/base/hooks/use-local-storage';
import { findKey, forEachItem, sortKeyList } from './utils';

const useLocalStorage = ({ key, itemKey, index }) => {
  const indexKey = `index-${key}`;
  const lastIndex = window.localStorage.getItem(indexKey) || 0;
  const nextIndex = index || parseInt(lastIndex, 10) + 1;
  const nextKey = `${key}-${itemKey}-${nextIndex}`;
  const currentKeyValue = `${key}-${itemKey}`;
  const currentKey = useRef(findKey(currentKeyValue));

  //
  const saveItem = (value) => {
    const isFreeSpace = isStorageAvailable(
      'localStorage',
      value.concat(nextIndex),
    );
    if (isFreeSpace && currentKey.current) {
      updateItemToLocalStorage(currentKey.current, value);
    } else if (isFreeSpace && !currentKey.current) {
      saveItemToLocalStorage(nextKey, value, indexKey, nextIndex);
      currentKey.current = findKey(currentKeyValue);
    } else {
      let allKeys = [];
      forEachItem(key, (localKey) => {
        allKeys.push({
          default: localKey,
          order: localKey.split('-').reverse().join('-'),
        });
      });
      allKeys = sortKeyList(allKeys);

      //when no space is available
      //free up items until we make enough space
      let existingStorageLength = 0;
      const currentStorageLength = (value || '').length;
      let logExistingKeys = [];
      allKeys.forEach(({ default: localKey }) => {
        existingStorageLength += (window.localStorage.getItem(localKey) || '')
          .length;
        logExistingKeys.push(localKey);

        if (existingStorageLength >= currentStorageLength) {
          logExistingKeys.forEach((k) => {
            window.localStorage.removeItem(k);
          });

          saveItemToLocalStorage(nextKey, value, indexKey, nextIndex);
          return true;
        }
      });
    }
  };

  const saveItemToLocalStorage = (k, v, ik, ni) => {
    window.localStorage.setItem(k, v);
    window.localStorage.setItem(ik, ni);
  };

  const updateItemToLocalStorage = (k, v) => {
    window.localStorage.setItem(k, v);
  };

  const clearItem = () => {
    if (currentKey.current) {
      window.localStorage.removeItem(currentKey.current);
    }
  };

  const getItem = () => {
    if (!currentKey.current) {
      return window.localStorage.getItem(findKey(currentKeyValue));
    }
    return window.localStorage.getItem(currentKey.current);
  };

  return [saveItem, clearItem, getItem];
};

useLocalStorage.propTypes = {
  props: PropTypes.shape({
    key: PropTypes.string,
  }),
};

export default useLocalStorage;
